import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');

    // Endpoints that should NOT have token attached
    const noAuthNeededEndpoints = [
      '/api/Token' // login endpoint
    ];

    // Endpoints that should not trigger logout on 401
    const ignore401Endpoints = [
      '/api/Token',
      '/api/Wallet'
    ];

    const skipAuth = noAuthNeededEndpoints.some(url => req.url.includes(url));
    const skip401Logout = ignore401Endpoints.some(url => req.url.includes(url));

    let modifiedReq = req;
    if (token && !skipAuth) {
      modifiedReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });
    }

    return next.handle(modifiedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !skip401Logout) {
          localStorage.removeItem('token');
          this.router.navigate(['/login']);
        }
        return throwError(() => error);
      })
    );
  }
}
